"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _emotion = require("emotion");

var root = function root(hasContent) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("border-radius:50%;", hasContent && "\n    > * {\n      overflow: hidden;\n      border-radius: inherit;\n    }\n  ")
  );
};

var _default = {
  root: root
};
exports.default = _default;